import * as z from 'zod'

export const FacebookSchema = z.object({
	username: z.string().nonempty(),
})

export type FacebookType = z.TypeOf<typeof FacebookSchema>